import styled from 'styled-components';

export const Table = styled.table(({ theme }) => ({
  tableLayout: 'fixed',
  borderCollapse: 'collapse',
  width: '100%',
  boxShadow: theme.shadows['400'],
  borderStyle: 'hidden',
  marginTop: 32,

  td: {
    border: `1px solid ${theme.colors.neutral['200']}`,
  },

  '@media print': {
    boxShadow: 'none',
    border: `1px solid ${theme.colors.neutral['200']}`,
    borderSpacing: 0,

    td: {
      borderRight: 0,
      borderTop: 0,

      '&:first-of-type': {
        borderLeft: 0,
      },
    },

    tr: {
      '&:last-of-type': {
        td: {
          borderBottom: 0,
        },
      },
    },
  },
}));
